import { Box } from '@mantine/core'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'

import { EarningsTabContainer } from '../../components/earnings-tab/components/EarningsTabContainer'

const earningsSearchSchema = z.object({
  page: z.number().int().positive().catch(1), // Default to page 1 if invalid or missing
})

export const Route = createFileRoute('/app/earnings')({
  component: RouteComponent,
  validateSearch: earningsSearchSchema,
})

function RouteComponent() {
  const { page } = useSearch({ from: Route.id })
  return (
    <Box w="100vw" ml="calc(-50vw + 50%)" mr="calc(-50vw + 50%)" h="100%" py={20} px={30}>
      <EarningsTabContainer page={page} />
    </Box>
  )
}
